import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledBottomNav = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  background: ${tvar('colors.fill.primary')};
  z-index: 4;

  button,
  fieldset {
    margin: 0 !important;
    flex-grow: 1;
  }

  @media (min-width: ${tvar('measures.breakpoints.tabletLg')}) {
    display: none;
  }
`;
